// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ISKo4CnGBHkP0OdpuJr1 > p {
  line-height: 2em;
}
.ISKo4CnGBHkP0OdpuJr1 > p > strong {
  display: block;
  background-color: var(--bar-background);
  font-size: 1em;
  padding: 0.1em 0.5em;
  border-radius: var(--dry-border-radius);
}
.ISKo4CnGBHkP0OdpuJr1 > div:last-of-type {
  margin-bottom: 3em;
}
.gtGmNB9tGTyb3C7eowq3 {
  display: flex;
  padding: 0.8em 0;
  align-items: center;
}
.gtGmNB9tGTyb3C7eowq3 > i {
  flex: 2em 0 0;
  font-size: 2em;
  text-align: center;
}
.qnh8nBe8UxyXpDBHM04A {
  margin-top: 2em;
  display: flex;
  flex-direction: column;
  gap: 1em;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ISKo4CnGBHkP0OdpuJr1`,
	"file": `gtGmNB9tGTyb3C7eowq3`,
	"checks": `qnh8nBe8UxyXpDBHM04A`
};
export default ___CSS_LOADER_EXPORT___;
